import { render } from "./OverviewConnections.vue?vue&type=template&id=97875976"
import script from "./OverviewConnections.vue?vue&type=script&lang=js"
export * from "./OverviewConnections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__